import axios from 'axios';
import { ToastError, removeCookie } from 'helpers/utis';
import Cookies from 'js-cookie';

import { useLocation } from 'react-router-dom';
import configBasedOnEnv from '../config';
import { Toast } from './toast';

export const axiosInstance = axios.create({
  headers: {}
});

export const cancelTokenSource = axios.CancelToken.source();

export const setAuthToken = (token) => {
  Cookies.set('authToken', token, { expires: 7 });
  return localStorage.setItem('token', token);
};

export const getAuthToken = () => {
  return localStorage.getItem('token') || localStorage.getItem('partnerToken');
};

export const getCookieToken = () => {
  return Cookies.get('authToken');
};

export const setLocalStorageData = (key, value) => {
  localStorage.setItem(key, value);
};

export const getLocalStorageData = (key) => {
  if (!key) return null;
  return JSON.parse(localStorage.getItem(key));
};

export const removeAuthToken = () => {
  if (typeof window !== 'undefined') localStorage.removeItem('token');
  Cookies.remove('token');
  Cookies.remove('authToken');
  return true;
};

export const logout = () => {
  axiosInstance.defaults.headers.common.Authorization = '';
  const theme = localStorage.getItem('theme');
  console.log('Before clear - theme:', theme);
  localStorage.clear();
  const themeAfterClear = localStorage.getItem('theme');
  console.log('After clear - theme:', themeAfterClear);
  if (theme) {
    localStorage.setItem('theme', theme);
    const themeAfterRestore = localStorage.getItem('theme');
    console.log('After restore - theme:', themeAfterRestore);
    document.documentElement.setAttribute('data-theme', theme);
  }
  removeCookie('token');
  ToastError('Logging out');
  setTimeout(() => {
    window.location.pathname = '/';
  }, 200);
};

export const getServiceUrl = (baseURL) => {
  let finalURL = '';

  switch (baseURL) {
    case 'user':
      finalURL = configBasedOnEnv.api.baseUrl;
      break;
    case 'normal':
      finalURL = configBasedOnEnv.api.normalService;
      break;
    case 'payment':
      finalURL = configBasedOnEnv.api.paymentService;
      break;
    case 'cms':
      finalURL = configBasedOnEnv.api.cmsService;
      break;
    case 'admin':
      finalURL = configBasedOnEnv.api.adminBaseUrl;
      break;
    case 'internal':
      finalURL = configBasedOnEnv.api.internalUrl;
      break;
    case 'manageCAD':
      finalURL = configBasedOnEnv.api.manageCadUrl;
      break;
    case 'manageCADV2':
      finalURL = configBasedOnEnv.api.manageCadUrlV2;
      break;
    case 'kycMicroservicesV2':
      finalURL = configBasedOnEnv.api.kycMicroservicesUrlV2;
      break;
    case 'testAgfinKyc':
      finalURL = configBasedOnEnv.api.testAgfinKyc;
      break;
    case 'lms':
      finalURL = configBasedOnEnv.api.lms;
      break;
    case 'API_GATEWAY':
      finalURL = configBasedOnEnv.api.API_GATEWAY;
      break;
    default:
      finalURL = configBasedOnEnv.api.normalService;
  }

  return finalURL;
};

export const statusHelper = (status, data, cancelLogout) => {
  if (!cancelLogout) {
    if (data.status === 401 && cancelTokenSource) cancelTokenSource.cancel();
    if (data.status === 401) {
      Toast({ type: 'error', message: data.statusText });
      setTimeout(() => logout(), 1000);
    }
  }
  if (status) {
    return {
      status: data.status,
      ...data.data
    };
  }
  return data.data;
};

export const scrollHelper = ({ isTop, isSmooth = true }) => {
  if (window) {
    const behavior = isSmooth ? 'smooth' : 'auto';

    if (isTop) {
      return window.scrollTo({ top: 0, behavior });
    }
  }

  return null;
};

export const isAuthorized = async () => {
  if (
    localStorage.getItem('token') !== null &&
    localStorage.getItem('token') !== undefined
  ) {
    return true;
  }
  return false;
};

export const renderStatus = (val) => {
  const status = val?.status?.toLowerCase();
  let className = '';
  if (status === 'active') {
    className = 'StatusActive';
  } else if (status === 'on hold') {
    className = 'StatusOnhold';
  } else if (status === 'pending approval') {
    className = 'StatusPending';
  } else if (status === 'in progress') {
    className = 'StatusInprogress';
  } else if (status === 'inactive') {
    className = 'StatusInactive';
  }
  return className;
};

export const useParamQuery = (val) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const paramValue = searchParams.get(val);
  return paramValue;
};
